export const transformArrObjectsToSelectOptions = (
  arrObjects: any[],
  configObject = { value: "id", label: "nombre" },
) => {
  const returnObjectKeys = Object.keys(configObject);

  return arrObjects.map((ctOption) => {
    let selectOption = { ...ctOption };
    // @ts-ignore
    returnObjectKeys.forEach(
      // @ts-ignore
      (ctKey) => (selectOption[ctKey] = ctOption[configObject[ctKey]]),
    );
    return selectOption;
  });
};

export const SI_NO_OPCIONES_SELECT = {
  SI: { id: 1, nombre: "Sí", value: 1 },
  NO: { id: 2, nombre: "No", value: 0 },
};

export const siNoOpcionesSelect = transformArrObjectsToSelectOptions(
  Object.values(SI_NO_OPCIONES_SELECT),
);

export const isNoSelected = (ctValue: any) => {
  return ctValue == SI_NO_OPCIONES_SELECT.NO.value;
};

export const hardcodeGrupoOptions = [
  { value: 1, label: "Opción uno" },
  { value: 2, label: "Opción dos" },
  { value: 3, label: "Opción tres" },
];
